import React, { useEffect, useState, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import {
  Subject,
  switchMap,
  map,
  catchError,
  of,
  takeUntil,
  tap,
  delay,
} from "rxjs";
import apiClient from "../../../../services/apiClient";
import rxErrorHandler from "../../../../common/helpers/rxErrorHandler";
import Beeswarm from "./Beeswarm";
import Tag from "../../models/Tag";
import { parseTags } from "./parseData";
import Loader from "../../../Loader";
import TimesIcon from "../../../icons/Times";

function TimeLine({ selectedItem, setSelectedTags, type, typeId }) {
  const bottomRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const { getTagAggregations } = apiClient;
    const destroy$ = new Subject();
    const field = "taggedWithTagsYears";
    const params = { size: 20000, field };

    of(null)
      .pipe(
        tap(() => setIsLoading(true)),
        switchMap(() => getTagAggregations(type, typeId, params)),
        map((x) => x.results),
        map((x) => parseTags(x)),
        tap(setTags),
        catchError(rxErrorHandler(() => {}, null)),
        delay(2000),
        tap(() => setIsLoading(false)),
        takeUntil(destroy$)
      )
      .subscribe();

    return () => destroy$.next();
  }, [type, typeId]);

  const scrollToFilter = () => {
    const { current: el } = bottomRef;
    if (!el) return;
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  };

  const onElementSelected = useCallback((item) => {
    if (item) {
      setSelectedTags(item);
      scrollToFilter();
    } else {
      setSelectedTags(item);
    }
  });

  return (
    <div className="tw-pb-6 tw-relative">
      <Beeswarm
        onElementSelected={onElementSelected}
        data={tags}
        selectedItem={selectedItem}
      />
      {isLoading ? (
        <div className="tw-absolute tw-inset-0 tw-bg-white">
          <Loader />
        </div>
      ) : null}

      <div className="tw-relative">
        {selectedItem ? (
          <div className="tw-py-6 tw-text-center tw-text-sm">
            <span className="tw-px-1">Showing publications mentioning:</span>
            <span className="tw-font-bold tw-px-0.5">
              &quot;{selectedItem.normalized}&quot;
            </span>

            {selectedItem.year ? (
              <>
                <span className="tw-px-1"> in {selectedItem.year}</span>
                <span className="tw-px-1">(Total: {selectedItem.count})</span>
              </>
            ) : null}

            <button
              type="button"
              className="tw-text-primary tw-bg-transparent tw-ml-3"
              data-tooltip="clear filter"
              onClick={() => {
                setSelectedTags(null);
              }}
            >
              <TimesIcon
                title="remove"
                className="hover:tw-text-black  tw-fill-current"
                size={10}
              />
            </button>
          </div>
        ) : null}
      </div>
      <div ref={bottomRef} />
    </div>
  );
}

TimeLine.propTypes = {
  type: PropTypes.string.isRequired,
  typeId: PropTypes.string.isRequired,
  selectedItem: PropTypes.instanceOf(Tag),
  setSelectedTags: PropTypes.func.isRequired,
};

TimeLine.defaultProps = {
  selectedItem: null,
};

export default TimeLine;
